import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import ITunesButton from "./buttons/ITunesButton";
import StictherButton from "./buttons/StictherButton";
import RssButton from "./buttons/RssButton";
import SpotifyButton from "./buttons/SpotifyButton";
import PlayerFMButton from "./buttons/PlayerFMButton";
import GooglePodcastsButton from "./buttons/GooglePodcastsButton";

export default () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          podcasts {
            iTunes
            stitcher
            googlepodcasts
            playerfm
            spotify
            rss
          }
        }
      }
    }
  `);
  return (
    <>
      <div className="flex flex-column items-center">
        {data.site.siteMetadata.podcasts.iTunes && (
          <ITunesButton url={data.site.siteMetadata.podcasts.iTunes} />
        )}
        {data.site.siteMetadata.podcasts.iTunes && (
          <GooglePodcastsButton
            url={data.site.siteMetadata.podcasts.googlepodcasts}
          />
        )}
        {data.site.siteMetadata.podcasts.spotify && (
          <SpotifyButton url={data.site.siteMetadata.podcasts.spotify} />
        )}
        {data.site.siteMetadata.podcasts.playerfm && (
          <PlayerFMButton url={data.site.siteMetadata.podcasts.playerfm} />
        )}

        {data.site.siteMetadata.podcasts.stitcher && (
          <StictherButton url={data.site.siteMetadata.podcasts.stitcher} />
        )}

        {data.site.siteMetadata.podcasts.rss && (
          <RssButton url={data.site.siteMetadata.podcasts.rss} />
        )}
      </div>
    </>
  );
};
